import { useState, useRef, useCallback, useEffect } from "react";

/**
 * Hook for showing a small inline annotation near a ref-bearing element.
 * Returns { ref, show(message, type?, duration?), visible, message, type }
 * Attach `ref` to any DOM element. Call `show()` to display a transient label.
 */
export const useInlineAnnotation = () => {
  const ref = useRef(null);
  const [state, setState] = useState({ visible: false, message: '', type: 'success' });
  const timerRef = useRef(null);

  const show = useCallback((message, type = 'success', duration = 1500) => {
    if (timerRef.current) clearTimeout(timerRef.current);
    setState({ visible: true, message, type });
    timerRef.current = setTimeout(() => {
      setState(s => ({ ...s, visible: false }));
    }, duration);
  }, []);

  useEffect(() => {
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);

  return { ref, show, ...state };
};